import {Tab} from 'semantic-ui-react';
import {ClueList} from './ClueList';


export const Clues = ({horizontalPatterns,verticalPatterns,selectedPattern,
    onListPatternClick,cellWidth,rows,cols,activeTab,setActiveTab,scrollVisible,isVerticalScreen})=>{

    
   /*  let horizontalClues = useRef();
    let verticalClues = useRef();   
 */
   /*  const [currentHeight,setCurrentHeight] = useState(300);

    const getCluesHeight = ()=>{
        const puzzleClues = document.getElementsByClassName('puzzle-border');
        if(puzzleClues.length > 0) return puzzleClues[0].clientHeight;
        else return 0;
    }; */
    
    //console.log('Clues height',cluesHeight);

   /*  useEffect(()=>{
        const interval = setInterval(()=>{
            const height = getCluesHeight();
            if(height!==currentHeight){
                console.log('setting height',height,currentHeight);
                setCurrentHeight(height);
            }
            
        },100);

        return ()=>{clearInterval(interval)}; 
    },[cellWidth,currentHeight]); */
    

    const panes = [
        {
            menuItem : 'Horizontal',
            render : ()=>(
                <Tab.Pane className="clues-tab">
                    {/* <Ref innerRef={horizontalClues}>
                        <Segment className="clues-segment" 
                            style={{border:'none',height:`${cluesHeight-80}px`}}
                            //style={{border:'none',height:`100%`}}
                        >
                            <ClueList patterns={horizontalPatterns} onListPatternClick={onListPatternClick} 
                                selectedPattern={selectedPattern}></ClueList>
                        </Segment>
                    </Ref> */}    

                    <div style={{height:`${cellWidth * rows-86}px`,overflow:'auto'}}>
                    <ClueList patterns={horizontalPatterns} onListPatternClick={onListPatternClick} 
                                selectedPattern={selectedPattern}></ClueList>
                    </div>

                </Tab.Pane>
                )
        },
        {
            menuItem : 'Vertical',
            render : ()=>(
                <Tab.Pane className="clues-tab">
                    {/* <Ref innerRef={verticalClues}>
                        <Segment className="clues-segment" style={{border:'none',height:`${cluesHeight-80}px`}}>
                        <ClueList patterns={verticalPatterns} onListPatternClick={onListPatternClick}
                        selectedPattern={selectedPattern}></ClueList>
                        </Segment>
                    </Ref> */}
                    <div style={{height:`${cellWidth * rows-86}px`,overflow:'auto'}}>
                    <ClueList patterns={verticalPatterns} onListPatternClick={onListPatternClick}
                        selectedPattern={selectedPattern}></ClueList>
                    </div>                    
                </Tab.Pane>
                )
        }
    ];


    const cluesStyle = {};

    if(isVerticalScreen){
        cluesStyle.width = `${cellWidth * cols}px`; 
    }else{
        cluesStyle.marginLeft = '16px';
    }


    return (
        <div className="puzzle-clues"  
        style={cluesStyle}
        // style={{height:`${cluesHeight}px`}}
        /* style={{height:`100%`}} */
        >
            <Tab onTabChange={(e,args)=>{setActiveTab(args.activeIndex);}} 
            menu={{color:'purple',inverted:true }} 
            panes={panes} activeIndex={activeTab} />
        </div>);

};